import React, { Component } from 'react'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

import classNames from './DownloadImages.css'
import Modal from './Modal'
import LoadingSpinner from '../LoadingSpinner'
import { slug } from '../../utils/string'

export default class DownloadImages extends Component {
  state = {
    downloaded: 0
  }
  filenames = {}
  componentDidMount () {
    this.mounted = true
    const { images, count, selectedImages, fetchAllImages } = this.props
    if (selectedImages.length !== 0) {
      this.startDownload(selectedImages)
    } else if (images.length === count) {
      this.startDownload(images)
    } else {
      fetchAllImages().then(() => {
        this.startDownload(this.props.images)
      })
    }
  }
  componentWillUnmount () {
    this.mounted = false
  }
  startDownload (images) {
    const blobs = []
    images.reduce((promise, id) => {
      return promise.then(() => {
        if (!this.mounted) {
          return Promise.reject()
        }
        return this.getImageBlob(id).then(blob => {
          blobs.push(blob)
        })
      })
    }, Promise.resolve()).then(() => {
      const zip = new JSZip()
      blobs.forEach(image => {
        zip.file(this.getFilename(image.id), image.blob)
      })
      zip.generateAsync({ type: 'blob' }).then(content => {
        saveAs(content, this.getFolderName())
      })
    })
  }
  getFilename = id => {
    let filename = this.props.entities.images[id]._filename
    if (this.filenames[filename]) {
      // Duplicate filename detected
      const base = filename.replace(/\.[^/.]+$/, '')
      const ext = filename.split('.').pop()
      let count = 1
      while (this.filenames[filename]) {
        filename = `${base} (${count}).${ext}`
        count++
      }
    }
    this.filenames[filename] = true
    return filename
  }
  getFolderName = () => {
    const { album, selectedImages } = this.props
    if (album) {
      const suffix = selectedImages.length !== 0 ? '-selection' : ''
      return `${slug(album.name)}${suffix}.zip`
    }
    return 'images.zip'
  }
  getImageBlob = id => {
    const { size, getImageSource } = this.props
    return window.fetch(getImageSource(id, size))
      .then(response => response.blob())
      .then(blob => {
        if (!this.mounted) {
          return Promise.reject()
        }
        this.setState({ downloaded: this.state.downloaded + 1 })
        return { id, blob }
      })
  }
  render () {
    const { count, selectedImages, onCancel } = this.props
    const { downloaded } = this.state
    const total = selectedImages.length || count
    return (
      <Modal title='Download Images' onClose={onCancel}>
        <div className={classNames.info}>
          <p>
            <progress max={total} value={downloaded} />
            <br />
            Preparing {downloaded} of {total} images
          </p>
          <button onClick={onCancel} className={classNames.button}>
            {downloaded === total ? 'Done' : 'Cancel'}
          </button>
          <LoadingSpinner show={downloaded !== total} />
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/DownloadImages.js